/* ydui-district v1.1.0 by YDCSS (c) 2017 Licensed ISC */
!function(){var district=[
    {
        "v": "1",
        "n": "希腊 ",
        "c": [
            {
                "v": "101",
                "n": "Athens - Center ",
                "c": [
                    {"v": "10101", "n": "Goudi "},
                    {"v": "10102", "n": "Ilisia "},
                    {"v": "10103", "n": "Kipseli "},
                    {"v": "10104", "n": "Patision - Acharnon "},
                    {"v": "10105", "n": "Neos Kosmos "},
                    {"v": "10106", "n": "Patisia "},
                    {"v": "10107", "n": "Petralona "},
                    {"v": "10108", "n": "Kentro "},
                    {"v": "10109", "n": "Agios Eleftherios - Probona - Rizoupoli "},
                    {"v": "10110", "n": "Ampelokipoi - Pentagon "},
                    {"v": "10111", "n": "Ano Patisia "},
                    {"v": "10112", "n": "Attiki "},
                    {"v": "10113", "n": "Gazi - Metaxourgio - Votanikos "},
                    {"v": "10114", "n": "Gizi - Pedion Areos "},
                    {"v": "10115", "n": "Exarchia - Neapoli "},
                    {"v": "10116", "n": "Historic Center "},
                    {"v": "10117", "n": "Kolonaki - Lykavittos "},
                    {"v": "10118", "n": "Kolonos - Kolokynthous "},
                    {"v": "10119", "n": "Koukaki - Makrygianni "},
                    {"v": "10120", "n": "Mets - Kalimarmaro "},
                    {"v": "10121", "n": "Pagkrati "},
                    {"v": "10122", "n": "Poligono - Tourkovounia "},
                    {"v": "10123", "n": "Sepolia - Skouze "}
                ]
			},
			{
                "v": "102",
                "n": "Athens - South ",
                "c": [
                    {"v": "10201", "n": "Agios Dimitrios "},
                    {"v": "10202", "n": "Alimos "},
                    {"v": "10203", "n": "Argyroupoli "},
                    {"v": "10204", "n": "Vari - Varkiza "},
                    {"v": "10205", "n": "Voula "},
                    {"v": "10206", "n": "Vouliagmeni "},
                    {"v": "10207", "n": "Vironas "},
                    {"v": "10208", "n": "Glyfada "},
                    {"v": "10209", "n": "Dafni "},
                    {"v": "10210", "n": "Elliniko "},
                    {"v": "10211", "n": "Zografou "},
                    {"v": "10212", "n": "Ilioupoli "},
                    {"v": "10213", "n": "Kaisariani "},
                    {"v": "10214", "n": "Kalithea "},
                    {"v": "10215", "n": "Nea Smyrni "},
                    {"v": "10216", "n": "Palaio Faliro "},
                    {"v": "10217", "n": "Imittos "}
                ]
			},
			{
                "v": "103",
                "n": "Athens - North ",
                "c": [
                    {"v": "10301", "n": "Agios Stefanos "},
                    {"v": "10302", "n": "Agia Paraskevi "},
                    {"v": "10303", "n": "Anoixi "},
                    {"v": "10304", "n": "Vrilissia "},
                    {"v": "10305", "n": "Dionisos "},
                    {"v": "10306", "n": "Drossia "},
                    {"v": "10307", "n": "Ekali "},
                    {"v": "10308", "n": "Iraklio "},
                    {"v": "10309", "n": "Kifissia "},
                    {"v": "10310", "n": "Krioneri "},
                    {"v": "10311", "n": "Lykovrisi "},
                    {"v": "10312", "n": "Marousi "},
                    {"v": "10313", "n": "Melissia "},
                    {"v": "10314", "n": "Nea Erithraia "},
                    {"v": "10315", "n": "Nea Penteli "},
                    {"v": "10316", "n": "Neo Psychiko "},
                    {"v": "10317", "n": "Papagou "},
                    {"v": "10318", "n": "Penteli "},
                    {"v": "10319", "n": "Pefki "},
                    {"v": "10320", "n": "Rodopoli "},
                    {"v": "10321", "n": "Stamata "},
                    {"v": "10322", "n": "Filothei "},
                    {"v": "10323", "n": "Chalandri "},
                    {"v": "10324", "n": "Cholargos "},
                    {"v": "10325", "n": "Paleo Psichiko "}
                ]
            },
			{
                "v": "105",
                "n": "Athens - East ",
                "c": [
                    {"v": "10501", "n": "Anthousa "},
                    {"v": "10502", "n": "Artemida (Loutsa) "},
                    {"v": "10503", "n": "Gerakas "},
                    {"v": "10504", "n": "Glika Nera "},
                    {"v": "10505", "n": "Koropi "},
                    {"v": "10506", "n": "Marathonas "},
                    {"v": "10507", "n": "Nea Makri "},
                    {"v": "10508", "n": "Paiania "},
                    {"v": "10509", "n": "Pallini "},
                    {"v": "10510", "n": "Spata "},
                    {"v": "10511", "n": "Varnavas "},
                    {"v": "10512", "n": "Grammatiko "},
                ]
            },
			{
                "v": "106",
                "n": "Athens - West ",
                "c": [
                    {"v": "10601", "n": "Agia Varvara "},
                    {"v": "10602", "n": "Agioi Anargiroi "},
                    {"v": "10603", "n": "Aigaleo "},
                    {"v": "10604", "n": "Acharnes "},
                    {"v": "10605", "n": "Galatsi "},
                    {"v": "10606", "n": "Ilion "},
                    {"v": "10607", "n": "Kamatero "},
                    {"v": "10608", "n": "Metamorfosi "},
                    {"v": "10609", "n": "Nea Ionia "},
                    {"v": "10610", "n": "Nea Philadelfia "},
                    {"v": "10611", "n": "Nea Chalkidona "},
                    {"v": "10612", "n": "Peristeri "},
	                {"v": "10613", "n": "Petroupoli "},
                    {"v": "10614", "n": "Chaidari "},						
                ]
            },
			{
                "v": "104",
                "n": "Athens - Other ",
                "c": [
                    {"v": "10401", "n": "其他地区 "},
                    {"v": "10402", "n": "Piraeus "},
                    {"v": "10403", "n": "Lagonisi "},
                    {"v": "10404", "n": "Saronida "},
                ]
            }
        ]
    }
	];if(typeof define==="function"){define(district)}else{window.YDUI_DISTRICT=district}}();